document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.collapsible-accordion');

  accordions.forEach(section => {
    const items = section.querySelectorAll('.ca-accordion-item');

    items.forEach(item => {
      const header = item.querySelector('.ca-accordion-header');
      const body = item.querySelector('.ca-accordion-body');

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');

        // Close siblings
        items.forEach(other => {
          if (other !== item) {
            other.classList.remove('active');
            const otherBody = other.querySelector('.ca-accordion-body');
            otherBody.style.maxHeight = null;
          }
        });

        // Toggle current
        if (isOpen) {
          item.classList.remove('active');
          body.style.maxHeight = null;
        } else {
          item.classList.add('active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  });
});
